import { MapPin, Phone, MessageCircle, Clock, Mail } from "lucide-react";
import SEO from "../components/SEO";
import { BUSINESS } from "../lib/data";

export default function Contatti() {
  return (
    <>
      <SEO
        title="Contatti | Il Velocipede - Rivenditore Ufficiale Piaggio e Kymco Roma Nuovo Salario"
        description="Contatta Il Velocipede a Roma. Telefono e WhatsApp +39 392 189 3121. Piazza dell'Ateneo Salesiano 79, Nuovo Salario - Roma Nord."
      />

      {/* HERO */}
      <section className="bg-[#013368] text-white" data-testid="contatti-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
          <div className="max-w-3xl">
            <span className="text-[#fd0100] text-xs uppercase tracking-[0.22em] font-semibold">Contatti</span>
            <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]">
              Contatta Il Velocipede
            </h1>
            <p className="mt-6 text-lg sm:text-xl text-slate-200 leading-relaxed">
              Siamo a tua disposizione per consulenze, preventivi, prenotazioni in officina e qualsiasi richiesta. Scegli il canale che preferisci.
            </p>
          </div>
        </div>
      </section>

      {/* CONTACT CARDS */}
      <section className="py-20 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7 space-y-5">
            <ContactCard
              icon={Phone}
              label="Telefono"
              primary={BUSINESS.phoneDisplay}
              desc="Chiamaci in orario di apertura per assistenza diretta."
              cta="Chiama Ora"
              href={`tel:${BUSINESS.phoneRaw}`}
              tone="red"
              testid="contact-card-call"
            />
            <ContactCard
              icon={MessageCircle}
              label="WhatsApp"
              primary={BUSINESS.whatsappDisplay}
              desc="Il modo più veloce per preventivi, foto del mezzo e prenotazioni."
              cta="Scrivici su WhatsApp"
              href={`https://wa.me/${BUSINESS.whatsappRaw}`}
              tone="wa"
              testid="contact-card-whatsapp"
            />
            <ContactCard
              icon={MapPin}
              label="Indirizzo"
              primary={`${BUSINESS.address}, ${BUSINESS.city}`}
              desc={`Quartiere ${BUSINESS.district}. Facilmente raggiungibile da Montesacro, Talenti, Conca d'Oro.`}
              cta="Apri in Google Maps"
              href={BUSINESS.mapsLink}
              external
              tone="blue"
              testid="contact-card-address"
            />
          </div>

          <div className="lg:col-span-5">
            <div className="bg-slate-50 border border-slate-200 rounded-2xl p-7 sticky top-28">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 rounded-lg bg-[#e6eff8] flex items-center justify-center">
                  <Clock className="w-5 h-5 text-[#013368]" />
                </div>
                <h2 className="font-display font-bold text-xl text-slate-900">Orari di apertura</h2>
              </div>
              <ul className="space-y-2 text-sm">
                {BUSINESS.hours.map((row) => (
                  <li key={row.d} className="flex justify-between gap-3 py-2 border-b border-slate-200 last:border-b-0">
                    <span className="text-slate-700 font-medium">{row.d}</span>
                    <span className="text-slate-500 text-right">{row.h}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-6 pt-6 border-t border-slate-200">
                <div className="text-xs text-slate-500 mb-3 flex items-center gap-2">
                  <Mail className="w-4 h-4" /> Pausa pranzo 13:00 – 15:30
                </div>
                <div className="text-xs text-slate-500">Festivi e giorni di chiusura straordinaria comunicati telefonicamente.</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MAP */}
      <section className="pb-24 bg-white" data-testid="contatti-map">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="rounded-2xl overflow-hidden border border-slate-200">
            <iframe
              title="Il Velocipede - Mappa"
              src={BUSINESS.mapsEmbed}
              width="100%"
              height="480"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </section>
    </>
  );
}

function ContactCard({ icon: Icon, label, primary, desc, cta, href, external, tone, testid }) {
  const btn =
    tone === "red" ? "btn-primary" : tone === "wa" ? "btn-wa" : "btn-secondary";
  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-7 flex flex-col md:flex-row md:items-center gap-5">
      <div className="w-14 h-14 rounded-xl bg-[#e6eff8] flex items-center justify-center shrink-0">
        <Icon className="w-7 h-7 text-[#013368]" />
      </div>
      <div className="flex-1">
        <div className="overline">{label}</div>
        <div className="mt-1 font-display font-bold text-xl text-slate-900">{primary}</div>
        <div className="mt-1 text-sm text-slate-600">{desc}</div>
      </div>
      <a
        href={href}
        target={external ? "_blank" : undefined}
        rel={external ? "noopener noreferrer" : undefined}
        data-testid={testid}
        className={`${btn} inline-flex items-center gap-2 px-5 py-3 rounded-full font-semibold text-sm whitespace-nowrap shrink-0`}
      >
        {cta}
      </a>
    </div>
  );
}
